import * as ReferralRequestLogic from './referral-request';
import * as ReferralResponseLogic from './referral-response';
import * as ReferralSaveLogic from './referral-saved';

export const logic = {
  ...ReferralRequestLogic,
  ...ReferralResponseLogic,
  ...ReferralSaveLogic,
};
